import { StandardsDto } from "src/data/models/standardsDtos/standardsDto.interface";
import { singleton } from "tsyringe";
import BaseService from "../Base/BaseService";

@singleton()
export class StandardsService extends BaseService {
  constructor() {
    super();

    this.setMiddlware(this.errorCatcher, [
      "getStandards",
      "addStandards",
      "editStandards",
      "deleteStandards",
    ]);
    this.setMiddlware(this.handleToken, [
      "getStandards",
      "addStandards",
      "editStandards",
      "deleteStandards",
    ]);
  }

  async getStandards(): Promise<Array<StandardsDto>> {
    const result = await this.repositoryWrapper.Standards.getStandards();
    return result.result;
  }

  async addStandards(data: StandardsDto): Promise<StandardsDto> {
    const result = await this.repositoryWrapper.Standards.addStandards(data);
    return result.result;
  }

  async editStandards(data: StandardsDto): Promise<StandardsDto> {
    const result = await this.repositoryWrapper.Standards.editStandards(data);
    return result.result;
  }
  async deleteStandards(standardId: number): Promise<number> {
    const result = await this.repositoryWrapper.Standards.deleteStandards(standardId);
    return result.result;
  }
}
